export default __webpack_public_path__ + "static/media/285645_user_icon.068fc1c3.png";